import { render, staticRenderFns } from "./BrandsComponent.vue?vue&type=template&id=aebe6eda&scoped=true"
import script from "./BrandsComponent.vue?vue&type=script&lang=js"
export * from "./BrandsComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandsComponent.vue?vue&type=style&index=0&id=aebe6eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe6eda",
  null
  
)

export default component.exports